const arr = (x) => Array.from(x);
const num = (x) => Number(x) || 0;
const isEmpty = (xs) => xs.length === 0;
const take = (n) => (xs) => xs.slice(0, n);
const drop = (n) => (xs) => xs.slice(n);
const reverse = (xs) => xs.slice(0).reverse();
const comp = (f) => (g) => (x) => f(g(x));
const not = (x) => !x;
const chunk = (n) => (xs) => isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))];

// numToWords :: (Number a, String a) => a -> String
export const numToWords = (n) => {
  const a = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen',
  ];

  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const g = [
    '',
    'Thousand',
    'Million',
    'Billion',
    'Trillion',
    'Quadrillion',
    'Quintillion',
    'Sextillion',
    'Septillion',
    'Octillion',
    'Nonillion',
  ];

  // this part is really nasty still
  // it might edit this again later to show how Monoids could fix this up
  const makeGroup = ([ones, tens, huns]) => {
    return [
      num(huns) === 0 ? '' : a[huns] + ' hundred ',
      num(ones) === 0 ? b[tens] : (b[tens] && b[tens] + ' ') || '',
      a[tens + ones] || a[ones],
    ].join('');
  };

  const thousand = (group, i) => (group === '' ? group : `${group} ${g[i]}`);

  if (typeof n === 'number') return numToWords(String(n));
  else if (n === '0') return 'zero';
  else
    return comp(chunk(3))(reverse)(arr(n))
      .map(makeGroup)
      .map(thousand)
      .filter(comp(not)(isEmpty))
      .reverse()
      .join(' ');
};

export const currencyToWords = {
  USD: {
    name: 'Dollar',
    plural: 'Dollars',
    fractionalUnit: {
      name: 'Cent',
      plural: 'Cents',
      symbol: '',
    },
  },
  GBP: {
    name: 'Pound',
    plural: 'Pounds',
    fractionalUnit: {
      name: 'Penny',
      plural: 'Pence',
      symbol: '',
    },
  },
  EUR: {
    name: 'Euro',
    plural: 'Euros',
    fractionalUnit: {
      name: 'Cent',
      plural: 'Cents',
      symbol: '',
    },
  },
  SEK: {
    name: 'Krona',
    plural: 'Krona',
    fractionalUnit: {
      name: 'Ore',
      plural: 'Ore',
      symbol: '',
    },
  },
  CAD: {
    name: 'Dollar',
    plural: 'Dollars',
    fractionalUnit: {
      name: 'Cent',
      plural: 'Cents',
      symbol: '',
    },
  },
  NOK: {
    name: 'Krone',
    plural: 'Krone',
    fractionalUnit: {
      name: 'Ore',
      plural: 'Ore',
      symbol: '',
    },
  },
  CHF: {
    name: 'Franc',
    plural: 'Franc',
    fractionalUnit: {
      name: 'Centimes',
      plural: 'Centimes',
      symbol: '',
    },
  },
  RUB: {
    name: 'Ruble',
    plural: 'Ruble',
    fractionalUnit: {
      name: 'Kopeks',
      plural: 'Kopeks',
      symbol: '',
    },
  },
  INR: {
    name: 'Rupee',
    plural: 'Rupees',
    fractionalUnit: {
      name: 'Paise',
      plural: 'Paise',
      symbol: '',
    },
  },
  CZK: {
    name: 'Koruna',
    plural: 'Koruna',
    fractionalUnit: {
      name: 'Halers',
      plural: 'Halers',
      symbol: '',
    },
  },
  PLN: {
    name: 'Zloty',
    plural: 'Zloty',
    fractionalUnit: {
      name: 'Groszy',
      plural: 'Groszy',
      symbol: '',
    },
  },
  AED: {
    name: 'Dirham',
    plural: 'Dirham',
    fractionalUnit: {
      name: 'Fils',
      plural: 'Fils',
      symbol: '',
    },
  },
  SAR: {
    name: 'Riyal',
    plural: 'Riyal',
    fractionalUnit: {
      name: 'Halalas',
      plural: 'Halalas',
      symbol: '',
    },
  },
  OMR: {
    name: 'Riyal-Omani',
    plural: 'Riyal-Omani',
    fractionalUnit: {
      name: 'Baiza',
      plural: 'Baiza',
      symbol: '',
    },
  },
  QAR: {
    name: 'Riyal',
    plural: 'Riyal',
    fractionalUnit: {
      name: 'Dirhams',
      plural: 'Dirhams',
      symbol: '',
    },
  },
  KWD: {
    name: 'Dinar',
    plural: 'Dinar',
    fractionalUnit: {
      name: 'Fils',
      plural: 'Fils',
      symbol: '',
    },
  },
  BHD: {
    name: 'Dinar',
    plural: 'Dinar',
    fractionalUnit: {
      name: 'Fils',
      plural: 'Fils',
      symbol: '',
    },
  },
  BGN: {
    name: 'Lev',
    plural: 'Lev',
    fractionalUnit: {
      name: 'Stotinki',
      plural: 'Stotinki',
      symbol: '',
    },
  },
  SGD: {
    name: 'Dollar',
    plural: 'Dollars',
    fractionalUnit: {
      name: 'Cent',
      plural: 'Cents',
      symbol: '',
    },
  },
  DKK: {
    name: 'Krone',
    plural: 'Krone',
    fractionalUnit: {
      name: 'Ore',
      plural: 'Ore',
      symbol: '',
    },
  },
  RON: {
    name: 'Leu',
    plural: 'Leu',
    fractionalUnit: {
      name: 'bani',
      plural: 'bani',
      symbol: '',
    },
  },
  NPR: {
    name: 'Rupee',
    plural: 'Rupees',
    fractionalUnit: {
      name: 'Paisa',
      plural: 'Paisa',
      symbol: '',
    },
  },
  AUD: {
    name: 'Dollar',
    plural: 'Dollars',
    fractionalUnit: {
      name: 'Cent',
      plural: 'Cents',
      symbol: '',
    },
  },
  NZD: {
    name: 'Dollar',
    plural: 'Dollars',
    fractionalUnit: {
      name: 'Cent',
      plural: 'Cents',
      symbol: '',
    },
  },
  HKD: {
    name: 'Dollar',
    plural: 'Dollars',
    fractionalUnit: {
      name: 'Cent',
      plural: 'Cents',
      symbol: '',
    },
  },
  MYR: {
    name: 'Ringgit',
    plural: 'Ringgit',
    fractionalUnit: {
      name: 'Sen',
      plural: 'Sen',
      symbol: '',
    },
  },
};
